import React from "react"
import { BgImage } from "gbimage-bridge"
import Navbar from "../components/Navbar"
import styled from "styled-components"

const BackDrop = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: -moz-linear-gradient(rgba(34,34,34,1) 0%, rgba(239,93,162,0.6) 60%, rgba(255,255,255,0.6) 100%);
  background-image: -webkit-linear-gradient(rgba(34,34,34,1) 0%, rgba(239,93,162,0.6) 60%, rgba(255,255,255,0.6) 100%);
  background-image: linear-gradient(rgba(34,34,34,1) 0%, rgba(239,93,162,0.6) 60%, rgba(255,255,255,0.6) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffff',endColorstr='#222222',GradientType=1);
`

export default function HeaderHome({ bgClass, imageData, children }) {

  return (
    <header>
      <Navbar/>
      <BgImage
        Tag="div"
        image={imageData}
        preserveStackingContext
        className={bgClass}
        backgroundColor={`background: rgb(34,34,34)`}
      >
        <BackDrop>
          { children }
        </BackDrop>
      </BgImage>
    </header>
  )
}